import {IUserProfileModel} from '../model/appModel';
import profileApi from '../service/profileApi';
import config from '../service/config';
import useSWR from 'swr';
import {GetKey, GetSessionStorage, SetSessionStorage} from '../util/StorageHelper';
import Constants from '../constants/Constants';

const fetchUserProfile = async (techSmithId: string) => techSmithId ? await profileApi.getUserProfileInfo(techSmithId) : {} as IUserProfileModel;

export const useUserProfileData = () => {
   const tscId = config?.user?.TechSmithId;
   const userProfileId = `UserProfileInfo-${tscId}`;
   const {data, error} = useSWR(userProfileId, () => fetchUserProfile(tscId), {
      revalidateOnFocus: false,
      onSuccess: results => SetSessionStorage(GetKey(Constants.swrKey, userProfileId), JSON.stringify(results)),
      fallback: () => JSON.parse(GetSessionStorage(GetKey(Constants.swrKey, userProfileId))) as IUserProfileModel
   });

   return {
      userProfile: data,
      isWorking: !error && !data,
      hasError: error
   };
};
